// extracted by mini-css-extract-plugin
module.exports = {"topAlert":"TopAlert_style_topAlert__1tdyE","preventMask":"TopAlert_style_preventMask__3qavz"};